module.exports = __webpack_public_path__ + "static/media/eaststreetlanes.5eaaf73c.jpg";